/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Idea: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M14.0001 20C14.5523 20 15.0001 20.4477 15.0001 21C15.0001 21.5523 14.5523 22 14.0001 22H10.0001C9.44777 22 9.00005 21.5523 9.00005 21C9.00005 20.4477 9.44777 20 10.0001 20H14.0001ZM15.0001 17C15.5523 17 16.0001 17.4477 16.0001 18C16.0001 18.5523 15.5523 19 15.0001 19H9.00005C8.44777 19 8.00005 18.5523 8.00005 18C8.00005 17.4477 8.44777 17 9.00005 17H15.0001ZM12.0001 1C17.9025 1.00004 21.3913 7.57903 18.4141 12.6035L18.2676 12.8418L16.7383 15.2305C16.4732 15.6447 16.0389 15.9233 15.5508 15.9863L15.3389 16H8.66118C8.16006 16 7.69681 15.7732 7.38579 15.3994L7.26177 15.2305L5.73247 12.8418C2.49839 7.78981 6.00384 1 12.0001 1ZM12.0001 3C7.67287 3 4.98696 7.96773 7.41704 11.7637L8.84868 14H15.1514L16.5831 11.7637L16.7959 11.4043C18.8435 7.66184 16.1919 3.00004 12.0001 3Z'
      fill='currentColor'
    />
  </React.Fragment>
)
